'use client';

import { useEffect } from 'react';
import { Grid, GridContainer } from '@trussworks/react-uswds';

import { useAwsRum } from 'src/components/ClientSideMonitoring/clientSideMonitoring';

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  const rum = useAwsRum();

  useEffect(() => {
    // Log error for reporting
    console.error(error);
    if (rum) {
      rum.recordError(error);
    }
  }, [rum, error]);

  return (
    // global-error must include html and body tags
    <html lang="en">
      <head>
        <title>Application Error</title>
        <meta name="robots" content="noindex" />
      </head>
      <body>
        <GridContainer>
          <main role="main">
            <Grid>
              {/* It is a typical nextjs behavior that global-error runs outside of our layout, so it
              doesn’t have access to NextIntlClientProvider. So it is best to use hard-coded text */}
              <h1 className="usa-display">The application is currently experiencing issues and is unavailable.</h1>
              <p>Please try again later.</p>
              {process.env.NODE_ENV !== 'production' && <pre>{error.message}</pre>}
            </Grid>
          </main>
        </GridContainer>
      </body>
    </html>
  );
}
